<div class="container-sm">

    <h2 class="help-header">Daily Fishing Log</h2>
    <ul>
        <li>From the home screen add a new record for each date of fishing, or select an existing date to edit:

        <img class="help-img" [src]="getImgs[0]"
           (click)="showImage(getImgs[0])" />
</li>
        <li>For each date, fill out your activity and catch. A location is required only if you were setting gear (even if there was no catch)</li>

        <img class="help-img" [src]="getImgs[1]"
           (click)="showImage(getImgs[1])" />

        <li>Record all catch that are kept or released. Fish counts are required but average weights are optional.</li>
        <li>The catch screen will give you an option to choose the species from a drop-down list or add favorite species so that they will be on the shortcut list.</li>

        <img class="help-img" [src]="getImgs[2]"
           (click)="showImage(getImgs[2])" />


    </ul>

    <h2 class="help-header">Delivery - Trip Information</h2>
    <ul>
        <li>From the home screen, enter your departure date and port. For all other trip info, select the "Delivery" button at the bottom of the home screen.</li>

        <img class="help-img" [src]="getImgs[3]"
           (click)="showImage(getImgs[3])" />

        <li>The "HMS Current Delivery" screen is a place to enter your return date and time, port, and vessel information. Also enter unloading (fish ticket) information.</li>

        <img class="help-img" [src]="getImgs[4]"
           (click)="showImage(getImgs[4])" />
    </ul>
</div>
